import React, { useEffect, useState } from 'react'
import { axiosInstance } from '../../axios/interceptor' // Assuming you have an axios instance
import axios from 'axios'
import { PropertyCardImg } from '../../helper/imagepath'
import { appendImageURL } from '../../helper/function'

const FilePreview = ({
  propertyImages,
  file,
  fileUuid,
  imageURL,
  onRemove,
  setImages,
  onChange,
  onProgressChange,
  setImageKey,
  image,
  module,
  isAddMode
}) => {
  const [imagePreview, setImagePreview] = useState(image || '')

  const getS3Post = async () => {
    try {
      const response = await axiosInstance.get(`/create-presigned-post-url-s3?module=${module}&name=${file.name}`)
      return response.data.data
    } catch (error) {
      console.error('Failed to get presigned URL.')
      throw new Error('Failed to get presigned URL.')
    }
  }

  const uploadToS3 = async (presignedPostUrl, formData) => {
    try {
      const response = await axios.post(presignedPostUrl.url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (data) => {
          const progress = Math.round((100 * data.loaded) / data.total)
          onProgressChange(fileUuid, progress) // Track progress
        }
      })

      if (response.status === 204) {
        const fileUrl = `${presignedPostUrl.fields.key}`
        setImageKey(`${presignedPostUrl.url}/${presignedPostUrl.fields.key}`)
        setImagePreview(fileUrl)
      }
    } catch (err) {
      console.error('Failed to upload to S3.')
      throw new Error('Failed to upload to S3.')
    }
  }

  const handleFileUpload = async (fileObj) => {
    try {
      const presignedPostUrl = await getS3Post()
      const formData = new FormData()

      formData.append('Content-Type', fileObj.type)
      Object.entries(presignedPostUrl.fields).forEach(([key, value]) => formData.append(key, value))
      formData.append('file', fileObj)

      await uploadToS3(presignedPostUrl, formData)
    } catch (error) {
      console.error(error.message)
    }
  }

  useEffect(() => {
    if (file) {
      handleFileUpload(file)
    } else {
      setImagePreview(imageURL)
    }
  }, [file])

  // remove image from s3 bucket
  const removeUploadedFileFromS3 = async (fileKey, image) => {
    const data = {
      files: [fileKey]
    }
    const newFilesUrl = propertyImages?.filter((file) => file !== image)

    if (isAddMode) {
      return await axiosInstance
        .post(`/delete-image-s3`, data)
        .then((response) => {
          // remove image from local state
          response && onRemove(fileUuid)
          response && onChange(newFilesUrl)
          response && setImages(newFilesUrl)
          return response
        })
        .catch((err) => {
          console.log('Error while removing file from S3:', err)
        })
    } else {
      onRemove(fileUuid)
      onChange(newFilesUrl)
      setImages(newFilesUrl)
    }
  }

  // const imageKey = `Img${imagePreview?.split('/Img')[1]}`

  return (
    <>
      {imagePreview && (
        <div className="image-preview-container">
          <img src={imagePreview ? appendImageURL(imagePreview) : PropertyCardImg} alt="preview" className="image-preview" />
          <button className="delete-icon" type="button" onClick={() => removeUploadedFileFromS3(imagePreview, imagePreview)}>
            &times;
          </button>
        </div>
      )}
    </>
  )
}

export default FilePreview
